import { Button } from "@/components/ui/button";
import { Empty } from "@/components/PageHeader";
import { money } from "@/lib/format";

export const ItcTab = ({ itc, onLock }) => {
  if (!itc) return <Empty label="No ITC data" hint="Run a 2B reconciliation for this period first." />;
  return (
    <div className="space-y-4" data-testid="itc-view">
      <div className="grid gap-px border border-border bg-border sm:grid-cols-5">
        {[["Opening ITC", itc.opening], ["Availed (2B eligible)", itc.availed],
          ["Reversed (Rule 37A)", itc.reversed], ["Utilised against output", itc.utilized],
          ["Closing balance", itc.closing]].map(([k, v]) => (
          <div key={k} className="bg-background p-4" data-testid={`itc-${k.split(" ")[0].toLowerCase()}`}>
            <p className="text-[10px] uppercase tracking-widest text-muted-foreground">{k}</p>
            <p className="num mt-1 font-semibold">{money(v)}</p>
          </div>
        ))}
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="panel">
          <p className="border-b border-border px-4 py-2 font-display text-sm font-bold">ITC by tax head</p>
          <table className="dense-table w-full">
            <tbody>
              {Object.entries(itc.heads).map(([k, v]) => (
                <tr key={k}><td className="uppercase">{k}</td><td className="num text-right">{money(v)}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="panel">
          <p className="border-b border-border px-4 py-2 font-display text-sm font-bold">Settlement</p>
          <table className="dense-table w-full">
            <tbody>
              <tr><td>Output tax for period</td><td className="num text-right">{money(itc.output_tax)}</td></tr>
              <tr><td>Credit available (opening + availed)</td><td className="num text-right">{money(itc.opening + itc.availed)}</td></tr>
              <tr className="font-semibold"><td>Net cash payable</td>
                <td className="num text-right" data-testid="net-cash-payable">{money(itc.net_cash_payable)}</td></tr>
            </tbody>
          </table>
          <div className="flex items-center justify-between gap-2 border-t border-border p-3">
            <p className="text-[11px] text-muted-foreground">
              {itc.locked ? "Period locked" : "Lock to carry the closing balance forward"}
            </p>
            <Button size="sm" variant="outline" onClick={onLock} disabled={itc.locked} data-testid="lock-itc-btn">
              {itc.locked ? "Locked" : "Lock period"}
            </Button>
          </div>
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{itc.note}</p>
    </div>
  );
};
